export default function() {
  $(document).ready(function() {
    var customer_id = $('[name="id"]').val()
    var token = $('[name="token"]').val()
    window.thinkwell.lib.inject('/account/reset', '/accounts/reset_password', '[action="/account/reset"]', {
      before: true,
      query: `customer_id=${customer_id}&token=${token}`
    });
  });
}
